import { CheckmarkCircleIcon, EmptyCircleIcon } from "../../icons/icons";
import './checkAllFilter.scss';

export interface CheckAllFilterProps {
    toggleCheckAll: (isChecked: boolean) => void;
}

function CheckAllFilter({toggleCheckAll}: CheckAllFilterProps) {

    return (
        <li className="check-uncheck-all-options" data-testid="check-all-filter">
            <label className="check-all-label" onClick={() => toggleCheckAll(true)}>
                <input type="radio" name="check-all-page-types" className="check-all" />
                <CheckmarkCircleIcon variant="check-all-icon" />
                Check all
            </label>
            <label className="uncheck-all-label" onClick={() => toggleCheckAll(false)}>
                <input type="radio" name="check-all-page-types" className="uncheck-all" />
                <EmptyCircleIcon variant="uncheck-all-icon" />
                Uncheck all
            </label>
        </li>
    );
}

export default CheckAllFilter;